import {z} from 'zod'

import {CreateOrUpdateBlockMediaSingleImageDocument} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {MediaLibraryFileType} from '../../../../MediaLibrary/types'

import type {BlockMediaSingleImageInput, CreateOrUpdateBlockMediaSingleImageMutation, XcNwBlock_BlockMediaSingleImageType_Fragment} from '@sdox/api'

export type UpdateSingleImageValidatorSchema = z.infer<typeof updateSingleImageValidatorSchema>

const updateSingleImageValidatorSchema = z.object({
  data: z.object({
    image: z.object({
      fileHash: z.string().min(1),
    }),
    imageMobile: z.object({
      fileHash: z.string().min(1),
    }).nullish(),
  }),
  meta: updateMetaSchema,
})

export const singleImageConfig = createFormConfig<
  UpdateSingleImageValidatorSchema,
  CreateOrUpdateBlockMediaSingleImageMutation,
  BlockMediaSingleImageInput,
  XcNwBlock_BlockMediaSingleImageType_Fragment
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockMediaSingleImageDocument,
  },
  fieldMapper: (fieldValues) => ({
    fileHash: fieldValues.data.image.fileHash,
    fileHashMobile: fieldValues.data.imageMobile?.fileHash,
  }),
  validatorSchema: updateSingleImageValidatorSchema,
  inputFields: [
    {
      label: 'Bild oder Video - Desktop',
      fieldName: 'data.image',
      inputType: 'file',
      fileTypes: [
        MediaLibraryFileType.Image,
        MediaLibraryFileType.Video,
      ],
      defaultValue: '',
      required: true,
    },
    {
      label: 'Bild oder Video - Mobile',
      fieldName: 'data.imageMobile',
      inputType: 'file',
      fileTypes: [
        MediaLibraryFileType.Image,
        MediaLibraryFileType.Video,
      ],
      defaultValue: '',
      required: false,
      description: 'Ist kein Element für Mobile ausgewählt, wird stattdessen das Desktop Element angezeigt.',
    },
  ],
  getDefaultValues: (block) => {
    const {imageMobile, image} = block
    return {
      data: {
        image: {
          ...image,
          fileHash: image.fileHash ?? '',
        },
        imageMobile,
      },
    }
  },
})
